const handler = response => {
    // X-Form-Errors is a string
    if (!response.headers.has("X-Form-Errors")) {
        // @TODO: In case of the login this is rendering the destination page
        //  and then redirecting to it. Not really efficient
        return response.text().then(data => {
            let url;
            try {
                url = JSON.parse(data).url;
            } catch (e) {}

            window.location = url || response.url || "/dashboard/";
        });
    }

    let newErrors = JSON.parse(response.headers.get("X-Form-Errors")).errors;
    for (var i = newErrors.length - 1; i >= 0; i--) {
        let err = newErrors[i];
        let validationName = err.property_path;

        const errFields = document.querySelectorAll(`[data-validation-name='${validationName}']`);
        if (errFields.length) {
            errFields.forEach(field => {
                field.setCustomValidity(err.message_raw);
                field.reportValidity();

                // Remove the error when new input
                // was added
                let curVal = field.value;
                const changeHandler = event => {
                    if (event.target.value === curVal) return;

                    field.setCustomValidity("");
                    field.removeEventListener("keyup", changeHandler);
                };

                field.addEventListener("keyup", changeHandler);
            });

            continue;
        }

        // No field found, add to global errors
        let globalErrors = document.getElementsByClassName("c-form__global-errors");
        if (globalErrors.length) {
            for (let globalError of globalErrors) {
                globalError.innerHTML = "";
                globalError.insertAdjacentHTML(
                    "afterbegin",
                    `<div class="c-input__error">${err.message_raw}</div>`,
                );
            }
        }
    }

    return false;
};

module.exports = handler;
